<ng-container *ngIf="unidad.show && visibilidad">
  <mat-card class="meta-mapping componente componente--5"
            [ngClass]="{'conexion-origen': (unidad.conexiones.selfColor.length > 1 && unidad.conexiones.active)}"
            [style.backgroundColor]="unidad.conexiones.activeColor">
    <div style="position: absolute; height: 100%; width: 100%; top: 0; left: 0; background: rgba(0,0,0, 0.4)"
         *ngIf="maskOn"></div>
    <div class="meta-mapping-header">
      <mat-card-title style="font-size: 13px; font-weight: bold; text-transform:uppercase;">
        <a [routerLink]="['/', 'estudio', 'unidad', unidad.id]" target="_blank">
          <b>{{unidad.nombre}}</b>
        </a>
      </mat-card-title>
      <div class="spacer"></div>
      <div class="flex-wrap" style="align-items: center">
        <mat-icon *ngIf="!isEmisorConexion && unidad.isFavorito" class="meta-header__indicador"
                  i18n-matTooltip="unidad favorita | unidad favorita@@unidadFavorita"
                  matTooltip="Unidad es favorita">
          bookmark
        </mat-icon>
        <mat-icon *ngIf="!isEmisorConexion && unidad.isNotificar"
                  class="meta-header__indicador"
                  i18n-matTooltip="notificaciones activas | notificaciones activas@@notificacionesActivas"
                  matTooltip="Notificaciones activadas">
          notifications
        </mat-icon>
        <div>
          <ng-container *ngFor="let indicador of unidad.conexionesActivas">
            <mat-icon matTooltip="{{indicador.codigo}}" class="indicador-conexion"
                      [style.color]="indicador.color">fiber_manual_record
            </mat-icon>
          </ng-container>
        </div>
        <div>
          <div *ngIf="!maskOn && !isEmisorConexion">
            <button mat-icon-button class="md-14" [matMenuTriggerFor]="menuMeta">
              <mat-icon class="material-icons md-14">more_vert</mat-icon>
            </button>
            <mat-menu #menuMeta="matMenu" xPosition="before" overlapTrigger="true">
              <button mat-menu-item *ngIf="unidad.isEditable" title="Editar unidad"
                      class="action-menu__item btn-sub3" (click)="editar(unidad.id)">
                <mat-icon>mode_edit</mat-icon>
                <span i18n="editar | editar@@editar">Editar</span>
              </button>
              <button mat-menu-item title="Mostrar conexiones" *ngIf="!unidad.setBulk"
                      (click)="mostrarConexiones('up');">
                <mat-icon>arrow_back</mat-icon>
                <span i18n="boton mostrar conexiones | boton conexiones@@btnConexiones">
                  <span *ngIf="unidad.conexiones.status.up; else ver">Ocultar</span>
                  <ng-template #ver>Ver</ng-template>
                  conexiones
                </span>
              </button>
              <button mat-menu-item *ngIf="unidad.isEditable" title="Conectar con metas"
                      class="action-menu__item btn-sub3" [ngClass]="{'on': conec}"
                      (click)="conectarCon();">
                <mat-icon>link</mat-icon>
                <span>Conectar con metas</span>
              </button>
              <button mat-menu-item (click)="estadoFavorita()">
                <mat-icon>{{unidad.isFavorito ? 'bookmark_border' : 'bookmark'}}</mat-icon>
                <span i18n="boton marcar favorita |boton favorita@@btnUnidadFavorita">
                  <span *ngIf="unidad.isFavorito; else marcarTpl">
                    Desmarcar
                  </span>
                  <ng-template #marcarTpl>Marcar</ng-template>
                  como favorita</span>
              </button>
              <button mat-menu-item (click)="estadoNotificaciones()">
                <mat-icon>{{unidad.isNotificar ? 'notifications_off' : 'notifications'}}</mat-icon>
                <span i18n="estado notificaciones | estado notificaciones@@btnEstadoNotificaciones">
                  <span *ngIf="unidad.isNotificar; else activarTpl">Desactivar</span>
                  <ng-template #activarTpl>Activar</ng-template>
                   notificaciones
                </span>
              </button>
            </mat-menu>
          </div>
          <div *ngIf="isEmisorConexion">
            <button mat-raised-button color="accent" (click)="finalizarConexion()" i18n="finalizar | finalizar@@finalizar">Finalizar</button>
          </div>
        </div>
      </div>
    </div>
    <mat-card-content>
      <div style="overflow: hidden;">{{unidad.resumen}}</div>
    </mat-card-content>
  </mat-card>
</ng-container>
